import axios from 'axios';

const requestHeaders = {
    'x-requested-with': 'XMLHttpRequest',
};

const getApiDomain = apiName => {
    if (apiName === apiNames.MEMBERSHIP) {
        switch (window.location.host) {
            case 'icsc.com':
            case 'www.icsc.com':
                return 'https://membership.icsc.com';

            case 'stage.icsc.com':
                return 'https://membership.stage.icsc.com';

            case 'webdev.icsc.com':
                return 'https://membership.webdev.icsc.com';

            case 'sync.icsc.test':
            case 'icsc.test:3000':
            case 'icsc.test':
                return 'https://membership.icsc.test';

            default:
                return 'https://membership.stage.icsc.com';
        }
    } else if (apiName === apiNames.TRANSACTION) {
        switch (window.location.host) {
            case 'icsc.com':
            case 'www.icsc.com':
                return 'https://transaction.icsc.com';

            case 'stage.icsc.com':
                return 'https://transaction.stage.icsc.com';

            case 'webdev.icsc.com':
                return 'https://transaction.webdev.icsc.com';

            case 'sync.icsc.test':
            case 'icsc.test:3000':
            case 'icsc.test':
                return 'https://transaction.icsc.test';

            default:
                return 'https://transaction.stage.icsc.com';
        }
    } else if (apiName === apiNames.DEALS) {
        switch (window.location.host) {
            case 'icsc.com':
            case 'www.icsc.com':
                return 'https://deals.icsc.com';

            case 'stage.icsc.com':
                return 'https://deals.stage.icsc.com';

            case 'webdev.icsc.com':
                return 'https://deals.webdev.icsc.com';

            case 'sync.icsc.test':
            case 'icsc.test:3000':
            case 'icsc.test':
                return 'https://deals.icsc.test';

            default:
                return 'https://deals.stage.icsc.com';
        }
    }
};

const apiNames = {
    MAIN: 'main',
    MEMBERSHIP: 'membership',
    TRANSACTION: 'transaction',
    DEALS: 'deals',
};

const get = (apiName, endpoint, headers = {}, config = {}) =>
    axios.get(`${getApiDomain(apiName)}/api/v1/${endpoint}`, {
        withCredentials: true,
        headers: { ...requestHeaders, ...headers },
        ...config,
    });

const getNoVersion = (apiName, endpoint, headers = {}) =>
    axios.get(`${getApiDomain(apiName)}/${endpoint}`, {
        withCredentials: true,
        headers: { ...requestHeaders, ...headers },
    });

const post = ({ apiName, endpoint, data = {}, headers = {}, overrideHeaders = false, addVersion = true }) => {
    const reqHeaders = !overrideHeaders ? { ...requestHeaders, ...headers } : headers;
    const url = `${getApiDomain(apiName)}${addVersion ? '/api/v1/' : '/'}${endpoint}`;

    return axios.post(url, data, {
        withCredentials: true,
        headers: reqHeaders,
    });
};

const patch = ({ apiName, endpoint, data, headers = {}, overrideHeaders }) => {
    const reqHeaders = !overrideHeaders ? { ...requestHeaders, ...headers } : headers;
    const url = `${getApiDomain(apiName)}/api/v1/${endpoint}`;

    return axios.patch(url, data, {
        withCredentials: true,
        headers: reqHeaders,
    });
};

const put = ({ url, apiName, endpoint, data, headers = {}, params = {} }) => {
    const reqHeaders = { ...requestHeaders, ...headers };
    const putUrl = apiName ? `${getApiDomain(apiName)}/api/v1/${endpoint}` : url;

    if (!putUrl) {
        console.error('No url for put request');
    }

    return axios.put(putUrl, data, {
        withCredentials: true,
        headers: reqHeaders,
        params,
    });
};

const postEE = ({ endpoint, data, headers }) =>
    axios.post(endpoint, data, {
        headers,
    });

const fetchQuery = ({ fetchRequest, transformData }) =>
    async function() {
        const response = await fetchRequest();
        let { data } = response.data;
        if (transformData) {
            data = transformData(data);
        }
        return data;
    };

const httpDelete = ({ apiName, endpoint, headers = {} }) =>
    axios.delete(`${getApiDomain(apiName)}/api/v1/${endpoint}`, {
        withCredentials: true,
        headers: { ...requestHeaders, ...headers },
    });

const getResponseData = async request => {
    try {
        const response = await request();
        const {
            data: { data },
        } = response;

        return data;
    } catch (error) {
        if (error.response.data.errors) {
            throw new Error(error.response.data.errors[0]);
        }

        throw new Error(error.message);
    }
};

const getDeals = ({ endpoint }) => axios.get(`${getApiDomain(apiNames.DEALS)}/${endpoint}`);
const postDeals = ({ endpoint, data }) => {
    const url = `${getApiDomain(apiNames.DEALS)}/${endpoint}`;
    return axios.post(url, data);
};

export {
    apiNames,
    get,
    getNoVersion,
    post,
    patch,
    put,
    httpDelete,
    postEE,
    fetchQuery,
    getResponseData,
    getDeals,
    postDeals,
};
